import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import Efficiency from '../../sumTotal/Efficiency';

class ViewEfficiency extends Component {
    state = {
        visible: false,
    }

    show = (crcUserId) => {
        this.setState({
            crcUserId,
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    render() {
        const { visible, crcUserId } = this.state;
        return (
            <Modal
                title="查看效率"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="900px"
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                {
                    visible && <div style={{ padding: 20 }}><Efficiency visible={visible} crcUserId={crcUserId} type="PERSONAL_EFFICIENCY" /></div>
                }
            </Modal>
        )
    }
}

export default ViewEfficiency;


// WEBPACK FOOTER //
// ./src/components/member/crcInfo/ViewEfficiency.js